import { useState, useEffect } from 'react';
import { getVisibleProducts } from '../../utils/exclusivePreview';

export default function Catalogue() {
  useEffect(() => {
    // SEO JSON-LD pour la page catalogue
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": "Catalogue - Créations artisanales | Les Carnets de Lolotte",
      "description": "Découvrez notre catalogue complet de créations artisanales en papier plié. Bouquets, animaux, symboles et personnalisations uniques.",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/catalogue`,
      "mainEntity": {
        "@type": "ItemList",
        "name": "Catalogue des créations artisanales",
        "numberOfItems": 8,
        "itemListElement": [
          {
            "@type": "Product",
            "name": "Bouquet de roses éternel",
            "category": "Bouquets et vases",
            "offers": {
              "@type": "Offer",
              "price": "41",
              "priceCurrency": "EUR"
            }
          },
          {
            "@type": "Product", 
            "name": "Cœur romantique",
            "category": "Cœurs & symboles",
            "offers": {
              "@type": "Offer",
              "price": "31",
              "priceCurrency": "EUR"
            }
          }
        ]
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    // Mise à jour des meta tags
    document.title = "Catalogue - Créations artisanales en papier plié | Les Carnets de Lolotte";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Découvrez notre catalogue complet de créations artisanales en papier plié. Bouquets, animaux, symboles et personnalisations uniques faites main.');
    }

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const allProducts = [
    {
      id: 1,
      name: 'Bouquet de roses éternel',
      price: '41O €',
      category: 'Bouquets et vases',
      description: 'Magnifique bouquet de roses créé à partir de pages de livres soigneusement pliées.',
      image: 'https://public.readdy.ai/ai/img_res/d287b884208651881c83ccd07a4f2dc5.jpg'
    },
    {
      id: 2,
      name: 'Cœur romantique',
      price: '31O €',
      category: 'Cœurs & symboles',
      description: 'Cœur délicat symbolisant l\'amour éternel, parfait pour une déclaration.',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20heart%20shape%20sculpture%20made%20from%20folded%20book%20pages%2C%20romantic%20book%20art%20creation%2C%20warm%20beige%20kraft%20paper%20background%2C%20soft%20artistic%20lighting%2C%20handmade%20craftsmanship%2C%20poetic%20and%20delicate%20design%2C%20detailed%20texture%20of%20folded%20pages&width=400&height=400&seq=7&orientation=squarish'
    },
    {
      id: 3,
      name: 'Papillon délicat',
      price: '20 €',
      category: 'Animaux',
      description: 'Papillon gracieux aux ailes finement travaillées, symbole de transformation.',
      image: 'https://static.readdy.ai/image/fd456b0d540e8f517714341c204b3126/5db5063a7f8b510c6e5253d463ff2ff0.png'
    },
    {
      id: 4,
      name: 'Vase fleuri',
      price: '54€',
      category: 'Bouquets et vases',
      description: 'Vase orné de fleurs en relief, une pièce unique pour votre intérieur.',
      image: 'https://readdy.ai/api/search-image?query=Artistic%20vase%20sculpture%20made%20from%20folded%20book%20pages%20with%20decorative%20flowers%2C%20handcrafted%20book%20art%20creation%2C%20warm%20kraft%20paper%20background%2C%20soft%20natural%20lighting%2C%20elegant%20home%20decoration%20piece%2C%20artisanal%20craftsmanship%2C%20detailed%20paper%20folding%20work&width=400&height=400&seq=9&orientation=squarish'
    },
    {
      id: 5,
      name: 'Chat mystérieux',
      price: '38€',
      category: 'Animaux',
      description: 'Silhouette féline élégante, parfaite pour les amoureux des chats.',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20cat%20silhouette%20sculpture%20made%20from%20folded%20book%20pages%2C%20artistic%20feline%20book%20art%2C%20warm%20beige%20kraft%20background%2C%20soft%20natural%20lighting%2C%20mysterious%20and%20graceful%20cat%20figure%2C%20handmade%20artisanal%20creation%2C%20detailed%20paper%20folding%20technique&width=400&height=400&seq=10&orientation=squarish'
    },
    {
      id: 6,
      name: 'Étoile brillante',
      price: '34€',
      category: 'Cœurs & symboles',
      description: 'Étoile scintillante apportant lumière et espoir dans votre foyer.',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20star%20sculpture%20crafted%20from%20folded%20book%20pages%2C%20shining%20star%20book%20art%20creation%2C%20warm%20kraft%20paper%20background%2C%20soft%20artistic%20lighting%2C%20symbol%20of%20hope%20and%20dreams%2C%20handmade%20artisanal%20work%2C%20intricate%20paper%20folding%20details&width=400&height=400&seq=11&orientation=squarish'
    },
    {
      id: 7,
      name: 'Oiseau en vol',
      price: '44€',
      category: 'Animaux',
      description: 'Oiseau aux ailes déployées, symbole de liberté et d\'évasion.',
      image: 'https://readdy.ai/api/search-image?query=Graceful%20bird%20sculpture%20with%20spread%20wings%20made%20from%20folded%20book%20pages%2C%20flying%20bird%20book%20art%2C%20warm%20beige%20kraft%20background%2C%20soft%20natural%20lighting%2C%20symbol%20of%20freedom%20and%20escape%2C%20handmade%20artisanal%20creation%2C%20detailed%20wing%20texture&width=400&height=400&seq=12&orientation=squarish'
    },
    {
      id: 8,
      name: 'Création personnalisée',
      price: 'Sur devis',
      category: 'Personnalisations',
      description: 'Votre idée transformée en réalité. Contactez-moi pour discuter de votre projet.',
      image: 'https://readdy.ai/api/search-image?query=Custom%20personalized%20book%20art%20sculpture%20being%20created%2C%20artisan%20hands%20working%20on%20folded%20book%20pages%2C%20warm%20kraft%20paper%20background%2C%20soft%20natural%20lighting%2C%20creative%20process%2C%20handmade%20customization%2C%20artistic%20workshop%20atmosphere%2C%20unique%20design&width=400&height=400&seq=13&orientation=squarish'
    }
  ];

  // Filtrer les produits en avant-première - utiliser getVisibleProducts
  const products = getVisibleProducts(allProducts);

  const categories = ['Tous', 'Animaux', 'Bouquets et vases', 'Cœurs & symboles', 'Personnalisations'];
  const [selectedCategory, setSelectedCategory] = useState('Tous');

  const filteredProducts = selectedCategory === 'Tous' 
    ? products 
    : products.filter(product => product.category === selectedCategory);

  return (
    <div className="min-h-screen bg-[#EDE3D2]">
      {/* Hero Section */}
      <header className="bg-[#FAFAFA] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold text-[#8C2F39] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Notre Catalogue
          </h1>
          <p className="text-xl text-[#2F2F2F] max-w-3xl mx-auto">
            Découvrez toutes nos créations uniques en livres pliés. 
            Chaque pièce raconte une histoire et apporte de la poésie dans votre quotidien.
          </p>
        </div>
      </header>

      {/* Filtres par catégorie */}
      <nav className="py-8 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-3 rounded-full font-medium transition-colors whitespace-nowrap ${
                  selectedCategory === category
                    ? 'bg-[#8C2F39] text-white'
                    : 'bg-gray-100 text-[#2F2F2F] hover:bg-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </nav>

      {/* Grille de produits */}
      <main className="py-16" data-product-shop>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {filteredProducts.map((product) => (
              <article key={product.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <div className="aspect-square overflow-hidden">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <span className="text-sm text-[#8C2F39] font-medium">{product.category}</span>
                  <h3 className="text-xl font-semibold text-[#2F2F2F] mt-2 mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
                    {product.name}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                    {product.description}
                  </p>
                  <div className="flex justify-between items-center">
                    <span className="text-2xl font-bold text-[#8C2F39]">{product.price}</span>
                    <button className="bg-[#8C2F39] text-white px-4 py-2 rounded-lg hover:bg-[#8C2F39]/90 transition-colors whitespace-nowrap">
                      <div className="w-5 h-5 flex items-center justify-center mr-2 inline-block">
                        <i className="ri-shopping-cart-line"></i>
                      </div>
                      Ajouter
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </section>
        </div>
      </main>
    </div>
  );
}
